export const capitalizeString = (str: string): string => str.charAt(0).toUpperCase() + str.substring(1);

export const stripHtml = (html: string) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.textContent || tempElement.innerText;
};

const getBrowserLanguage = () => {
    return window.navigator.language;
};

export const formatDateString = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(getBrowserLanguage(), {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

